"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.css = exports.props = exports.IMG_BOX = exports.IMG_WIDTH = void 0;
// @ts-ignore
var imageClientSDK_1 = __importDefault(require("image-client-api/dist/imageClientSDK")); // eslint-disable-line no-restricted-syntax
var withCompInfo_1 = require("../../core/withCompInfo");
// @ts-ignore
var IMG_TRANSFORM_TYPE = { transformType: 'fit', quality: 90 };
var getImageUrl = function (_a) {
    var uri = _a.uri, width = _a.width, height = _a.height;
    return imageClientSDK_1.default.getScaleToFillImageURL(uri, width, height, width, height, IMG_TRANSFORM_TYPE);
};
/**
 * Will split a given array to multiple arrays.
 * example: ([1,2,3,4,5], 2) => [[1,2],[3,4],[5]]
 * @param data data to be split to rows
 * @param itemsPerRow maximum number of items per row
 */
var splitToRows = function (data, itemsPerRow) {
    return Array.from({ length: Math.ceil(data.length / itemsPerRow) }, function (v, i) {
        return data.slice(i * itemsPerRow, i * itemsPerRow + itemsPerRow);
    });
};
var IMG_SPACING = 20;
exports.IMG_WIDTH = 250;
exports.IMG_BOX = exports.IMG_WIDTH + IMG_SPACING;
exports.props = withCompInfo_1.withCompInfo(['compProps', 'compLayout'], function (_a, carmiProps) {
    var compProps = _a.compProps, compLayout = _a.compLayout;
    var _b = carmiProps.images, images = _b === void 0 ? [] : _b;
    var _c = compLayout.width, compWidth = _c === void 0 ? exports.IMG_BOX : _c;
    var type = compProps.type, textMode = compProps.textMode;
    var renderTitle = ['titleAndDescription', 'titleOnly'].includes(textMode);
    var renderDescription = ['titleAndDescription', 'descriptionOnly'].includes(textMode);
    var imagesForSeo = images.map(function (image) {
        var uri = image.uri, imageWidth = image.width, imageHeight = image.height, title = image.title, description = image.description, alt = image.alt, imageProps = __rest(image, ["uri", "width", "height", "title", "description", "alt"]);
        var sizeRatio = imageWidth / imageHeight;
        var width = exports.IMG_WIDTH;
        var height = Math.floor(exports.IMG_WIDTH / sizeRatio);
        return __assign(__assign(__assign(__assign({}, imageProps), { alt: alt || title, uri: getImageUrl({ uri: uri, width: width, height: height }), width: width,
            height: height }), (renderTitle && { title: title })), (renderDescription && { description: description }));
    });
    var itemsPerRow = Math.floor(compWidth / exports.IMG_BOX);
    return {
        type: type.replace('Properties', ''),
        images: splitToRows(imagesForSeo, itemsPerRow),
    };
});
exports.css = withCompInfo_1.withCompInfo(['compLayout'], function (_a) {
    var compLayout = _a.compLayout;
    return ({
        '--height': compLayout.height + "px",
    });
});
//# sourceMappingURL=SeoTpaGallery.js.map